/*
 * @Author: wupeiwen <javapeiwen2010@gmail.com>
 * @Date: 2022-06-06 16:12:24
 * @LastEditors: wupeiwen <javapeiwen2010@gmail.com>
 * @LastEditTime: 2022-06-17 11:15:01
 * @FilePath: /jy-dashboard-web/src/util/storeModules/company-profile.js
 * @Description: 描述
 */
import { DataView } from '@antv/data-set'
import { get } from '@/util/http.js'
export default {
  state: {
    loading: {},
    // 地图统计
    dttj: [],
    // 地图分布
    dtfb: [],
    // 茶产业
    ccy: {
      sc_proportion: [],
      sc_trend: []
    },
    // 茶科技
    ckj: [],
    // 为农服务
    wnfw: {
      statistics_data: [],
      course_data: []
    },
    // 新闻列表
    gsxw: [],
    // 企业荣誉
    qyry: [],
    // 企业认证
    qyrz: []
  },
  getters: {},
  mutations: {},
  actions: {
    // 地图统计
    async getDTTJ ({ state }) {
      state.loading.dttj = true
      try {
        const { data } = await get({ url: '/View/TeaStatistics' })
        state.dttj = data
      } catch (error) {
        console.log(error)
      }
      state.loading.dttj = false
    },
    // 茶产业
    async getCCY ({ state }) {
      state.loading.ccy = true
      try {
        const { data } = await get({ url: '/View/ScData' })
        data.sc_proportion = new DataView().source(data.sc_proportion).transform({
          type: 'percent',
          field: 'value',
          dimension: 'name',
          groupBy: ['year'],
          as: 'percent'
        }).transform({
          type: 'map',
          callback (row) {
            row.percent = Math.round(row.percent * 100)
            return row
          }
        }).rows
        data.total = new DataView().source(data.sc_trend).transform({
          type: 'filter',
          callback (row) {
            return row.name === '产业总值'
          }
        }).rows
        const total = {}
        data.total.map(item => {
          total[item.year] = item.value
          return item
        })
        data.sc_trend = new DataView().source(data.sc_trend).transform({
          type: 'filter',
          callback (row) {
            return row.name !== '产业总值'
          }
        }).transform({
          type: 'percent',
          field: 'value',
          dimension: 'name',
          groupBy: ['year'],
          as: 'percent'
        }).transform({
          type: 'map',
          callback (row) {
            row.percent = Math.round(row.percent * 100)
            row.total = total[row.year]
            return row
          }
        }).transform({
          type: 'sort-by',
          fields: ['year'],
          order: 'ASC'
        }).rows
        state.ccy = data
      } catch (error) {
        console.log(error)
      }
      state.loading.ccy = false
    },
    // 茶科技
    async getCKJ ({ state }) {
      state.loading.ckj = true
      try {
        const { data } = await get({ url: '/View/CkjData' })
        state.ckj = data
      } catch (error) {
        console.log(error)
      }
      state.loading.ckj = false
    },
    // 为农服务
    async getWNFW ({ state }) {
      state.loading.wnfw = true
      try {
        const { data } = await get({ url: '/View/FarmService' })
        state.wnfw = data
      } catch (error) {
        console.log(error)
      }
      state.loading.wnfw = false
    },
    // 企业荣誉
    async getQYRY ({ state }) {
      state.loading.qyry = true
      try {
        const { data } = await get({ url: '/View/CompanyHonor' })
        state.qyry = data
      } catch (error) {
        console.log(error)
      }
      state.loading.qyry = false
    },
    // 企业认证
    async getQYRZ ({ state }) {
      state.loading.qyrz = true
      try {
        await new Promise((resolve) => setTimeout(resolve, 3000))
        state.qyrz = [
          { name: 'HACCP认证', value: 'HACCP Certification' },
          { name: 'FSSC22000认证', value: 'FSSC22000 Certification' },
          { name: 'SA8000认证', value: 'SA8000 Certification' },
          { name: 'ISO9001质量管理体系认证', value: 'ISO9001 Certification' },
          { name: 'FDA认证', value: 'FDA Certification' },
          { name: '中国有机认证', value: 'China Organic Certification' },
          { name: 'USDA认证', value: 'USDA Certification' },
          { name: 'EU认证', value: 'EU Certification' },
          { name: 'HALAL认证', value: 'HALAL Certification' },
          { name: 'KOSHER认证', value: 'KOSHER Certification' },
          { name: '雨林认证', value: 'RA Certification' },
          { name: 'FAIRTRADE认证', value: 'FAIRTRADE Certification' },
          { name: 'NATURLAND认证', value: 'NATURLAND Certification' }
        ]
      } catch (error) {
        console.log(error)
      }
      state.loading.qyrz = false
    },
    // 地图分布
    async getDTFB ({ state }) {
      state.loading.dtfb = true
      try {
        const { data } = await get({ url: '/View/BaseInfo' })
        state.dtfb = data
      } catch (error) {
        console.log(error)
      }
      state.loading.dtfb = false
    },
    // 新闻列表
    async getGSXW ({ state }) {
      state.loading.gsxw = true
      try {
        const { data } = await get({ url: '/View/CompanyNewList' })
        state.gsxw = data
      } catch (error) {
        console.log(error)
      }
      state.loading.gsxw = false
    }
  }
}
